module.exports = __webpack_public_path__ + "static/media/invite-card.f31ed7d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/invite-card.png
// module id = 1001
// module chunks = 0